// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type TriggerQaDatabaseResetMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type TriggerQaDatabaseResetMutation = { __typename?: 'Mutation', triggerQaDatabaseReset: { __typename?: 'TriggerQaDatabaseResetResult', triggered: boolean, message: string } };


export const TriggerQaDatabaseResetDocument = gql`
    mutation TriggerQaDatabaseReset {
  triggerQaDatabaseReset {
    triggered
    message
  }
}
    `;
export type TriggerQaDatabaseResetMutationFn = Apollo.MutationFunction<TriggerQaDatabaseResetMutation, TriggerQaDatabaseResetMutationVariables>;

/**
 * __useTriggerQaDatabaseResetMutation__
 *
 * To run a mutation, you first call `useTriggerQaDatabaseResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerQaDatabaseResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerQaDatabaseResetMutation, { data, loading, error }] = useTriggerQaDatabaseResetMutation({
 *   variables: {
 *   },
 * });
 */
export function useTriggerQaDatabaseResetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TriggerQaDatabaseResetMutation, TriggerQaDatabaseResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TriggerQaDatabaseResetMutation, TriggerQaDatabaseResetMutationVariables>(TriggerQaDatabaseResetDocument, options);
      }
export type TriggerQaDatabaseResetMutationHookResult = ReturnType<typeof useTriggerQaDatabaseResetMutation>;
export type TriggerQaDatabaseResetMutationResult = Apollo.MutationResult<TriggerQaDatabaseResetMutation>;
export type TriggerQaDatabaseResetMutationOptions = Apollo.BaseMutationOptions<TriggerQaDatabaseResetMutation, TriggerQaDatabaseResetMutationVariables>;